import { PolicyControl } from "./PolicySections.types";

// Resolves the stored link ids to their display models; ids without a match (e.g. a control that became
// excluded or archived after linking) are dropped rather than shown as broken chips.
export function resolveControls(controlIds: Array<string>, availableControls: Array<PolicyControl>): Array<PolicyControl> {
    return controlIds.map((id) => availableControls.find((control) => control.id === id)).filter((control): control is PolicyControl => control !== undefined);
}
